import BaseApi from "../BaseApi";

const baseApi = new BaseApi();

export default class Ai {
	Entity = "ai";
	
	check = async (id = null) => {
		const action = "status";
		const processedData = {
			id
		};
		
		return baseApi.fullFetch(this.Entity, action, {data: processedData});
	}
	
	create = async (data = null) => {
		if (!data) {
			throw new Error("Data is null...!!!");
		}
		
		const action = "send";
		const processedData = {
			...data,
		};
		
		return baseApi.fullFetch(this.Entity, action, {data: processedData});
	}
	
	list = async (studyID = null) => {
		const action = "get";
		const processedData = {
			study_id: studyID
		};
		
		return baseApi.fullFetch(this.Entity, action, {data: processedData});
	}
}